import { Modal, Typography } from '@getsynapse/design-system';
import { ModalProps } from '@getsynapse/design-system/dist/Organisms/Modal/Modal';
import intl from 'react-intl-universal';
import { BudgetModel } from '../../../../../../utils/customTypes';

export type ChangeActiveStatusModalProps = ModalProps & {
  onChangeStatus: () => void;
  onCancel: () => void;
  budget?: BudgetModel;
  type: ActiveStatusTypeEnum;
};

export enum ActiveStatusTypeEnum {
  REMOVE = 'REMOVE',
  REPLACE = 'REPLACE',
}

export const ChangeActiveStatusModal = ({
  onChangeStatus,
  onCancel,
  budget,
  type,
  ...props
}: ChangeActiveStatusModalProps) => {
  function isRemove() {
    return type === ActiveStatusTypeEnum.REMOVE;
  }

  return (
    <Modal
      {...props}
      data-cy='change-budget-status-modal'
      aria-label={
        isRemove()
          ? intl.get('BUDGET_PAGE.ACTIVE_STATUS_MODAL.REMOVE_TITLE', {
              title: budget?.title,
            })
          : intl.get('BUDGET_PAGE.ACTIVE_STATUS_MODAL.REPLACE_TITLE')
      }
      titleIcon={{
        name: 'information-circle-outline',
      }}
      title={
        isRemove()
          ? intl.get('BUDGET_PAGE.ACTIVE_STATUS_MODAL.REMOVE_TITLE')
          : intl.get('BUDGET_PAGE.ACTIVE_STATUS_MODAL.REPLACE_TITLE')
      }
      size='small'
      actionButtons={[
        {
          children: isRemove()
            ? intl.get('BUDGET_PAGE.ACTIVE_STATUS_MODAL.CONFIRM_REMOVE')
            : intl.get('BUDGET_PAGE.ACTIVE_STATUS_MODAL.CONFIRM_REPLACE'),
          onClick: onChangeStatus,
          'data-cy': 'change-budget-status_button',
          variant: 'primary',
        },
        {
          children: intl.get('CANCEL'),
          variant: 'tertiary',
          onClick: onCancel,
          'data-cy': 'cancel_button',
        },
      ]}
    >
      <Typography>
        {isRemove() &&
          intl.get('BUDGET_PAGE.ACTIVE_STATUS_MODAL.REMOVE_DESC', {
            year: budget?.fiscalPeriodStart
              ? new Date(budget?.fiscalPeriodStart ?? '').getFullYear()
              : new Date().getFullYear(),
          })}
        {!isRemove() &&
          intl.get('BUDGET_PAGE.ACTIVE_STATUS_MODAL.REPLACE_DESC', {
            title: budget?.title,
          })}
      </Typography>
    </Modal>
  );
};
